// Funciones de lógica para los comodines del quiz

// Función para usar un comodín


// Control de uso de 50/50 por pregunta
let cincuentaUsadoPorPregunta = {};

export const usarComodinLogica = (
  tipo,
  comodines,
  setComodines,
  respuestasVisibles,
  respuestaRevelada,
  preguntaActual,
  respuestasMezcladas,
  setRespuestasVisibles,
  setRespuestasEliminadas,
  setTiempoLlamada,
  setTemporizadorLlamadaActivo,
  setMostrarTemporizadorLlamada,
  setMostrarGraficoPublico,
  setTiempoRestantePublico,
  setTemporizadorPublicoActivo,
  forzar = false,
  extra = {}
) => {
  // Si es 50/50 y ya se usó en esta pregunta, solo se permite con soborno (forzar)
  if (tipo === 'cincuenta' && cincuentaUsadoPorPregunta[preguntaActual] && !forzar) {
    return false;
  }

  // Verificar condiciones antes de usar el comodín. Con soborno (forzar) se
  // puede reutilizar cualquier comodín agotado, mago incluido.
  if ((!forzar && comodines[tipo] <= 0) || respuestasVisibles < 4 || respuestaRevelada) {
    return false;
  }

  // Si todas las condiciones son válidas, usar el comodín

  setComodines(prev => ({
    ...prev,
    [tipo]: prev[tipo] > 0 ? prev[tipo] - 1 : 0 // No baja de 0
  }));

  // Lógica para cada comodín
  switch (tipo) {
    case 'llamada':
      setTiempoLlamada(30);
      setTemporizadorLlamadaActivo(true);
      setMostrarTemporizadorLlamada(true);
      break;
    case 'publico':
      setMostrarGraficoPublico(true);
      setTiempoRestantePublico(30);
      setTemporizadorPublicoActivo(true);
      break;
    case 'cincuenta': // Nuevo comodín 50/50
      // Marcar como usado para esta pregunta
      cincuentaUsadoPorPregunta[preguntaActual] = true;
      // Eliminar 2 respuestas incorrectas aleatoriamente
      if (respuestasMezcladas && respuestasMezcladas.length > 0) {
        // Actualizar el estado de respuestas eliminadas. Se eligen dentro del
        // updater para no repetir las ya eliminadas si el 50/50 se reutiliza
        // con soborno en la misma pregunta.
        setRespuestasEliminadas(prev => {
          const yaEliminadas = (prev && prev[preguntaActual]) || [];
          // Obtener índices de respuestas incorrectas que aún se ven
          const copiaIndices = respuestasMezcladas
            .map((respuesta, index) => ({ index, esCorrecta: respuesta.esCorrecta }))
            .filter(item => !item.esCorrecta && !yaEliminadas.includes(item.index))
            .map(item => item.index);
          // Elegir 2 índices aleatorios de respuestas incorrectas
          const indicesAEliminar = [];
          for (let i = 0; i < 2 && copiaIndices.length > 0; i++) {
            const indiceAleatorio = Math.floor(Math.random() * copiaIndices.length);
            indicesAEliminar.push(copiaIndices[indiceAleatorio]);
            copiaIndices.splice(indiceAleatorio, 1);
          }
          return { ...prev, [preguntaActual]: [...yaEliminadas, ...indicesAEliminar] };
        });
      }
      break;
    case 'mago':
      // Lógica para el mago: llamada a backend y callback para actualizar pregunta
      if (extra && typeof extra.cambiarPregunta === 'function') {
        extra.cambiarPregunta();
      }
      break;
    default:
      console.warn(`Tipo de comodín no reconocido: ${tipo}`);
      // Restaurar el comodín si es un tipo no reconocido
      setComodines(prev => ({
        ...prev,
        [tipo]: prev[tipo] + 1
      }));
      return false;
  }
  return true;
};

// Función para reiniciar comodines
export const resetComodinesLogica = (
  setComodines,
  setMostrarTemporizadorLlamada,
  setTemporizadorLlamadaActivo,
  setTiempoLlamada,
  setMostrarGraficoPublico,
  setTemporizadorPublicoActivo,
  setTiempoRestantePublico
) => {
  // Reiniciar control de 50/50 por pregunta
  cincuentaUsadoPorPregunta = {};
  setComodines({
    llamada: 1,
    publico: 1,
    cincuenta: 1,
    mago: 1
  });
  setMostrarTemporizadorLlamada(false);
  setTemporizadorLlamadaActivo(false);
  setTiempoLlamada(30);
  setMostrarGraficoPublico(false);
  setTemporizadorPublicoActivo(false);
  setTiempoRestantePublico(30);
};
